import React from 'react'

export default function Footers() {
  return (
    <div className='footer' >
    <div><h1>Follow us</h1></div>
    <div className='social' ><i class="fa-brands fa-facebook"></i>
    <i class="fa-brands fa-instagram"></i>
    <i class="fa-brands fa-twitter"></i>
    <i class="fa-brands fa-linkedin"></i>
    <i class="fa-brands fa-youtube"></i>
    <i class="fa-brands fa-tiktok"></i>

  
    
    
    
    </div>
    <hr />
    <div className='f'>
    <i class="fa-solid fa-copyright"></i> <span>2023 Alec's Bakery|| Rachamalla Abhishek Kumar</span> 
    </div>
  </div>
  )
}
